import { parseFolders } from './parsers/folders';
import { toError } from './parsers/error';
export function initFolders(settings, http) {
  function list(folderId, options) {
    if (folderId) {
      // Google Photos doesn't have folders inside folders, so we can omit requesting server and return resolved promise right away
      return Promise.resolve({
        data: []
      });
    }
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      pageSize: Math.min(options.paging.size || settings.foldersLimit, settings.foldersLimit),
      pageToken: options.paging.cursor
    };
    return http.get(`${settings.apiUrl}${settings.apiPath}/albums`, requestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(parseFolders).catch(toError);
  }
  return {
    list
  };
}